module.exports = __webpack_public_path__ + "static/media/footer_1.44201f81.png";